import { ReactElement, useContext, useState } from "react"
import { AuthContext, Rotina } from "../../../context/Auth";
import { Agrup, ButtonRotina, Icon, Organize, Seta, SubAgrup } from "../style";
import batismo from "../../../assets/img/Batismo.svg";
import seta from "../../../assets/img/seta.svg";
import { ButtonMenu } from "../ButtonMenu";
import { useLocation } from "react-router-dom";

export const MenuBatismo = (): ReactElement | null => {

  const { usuarioRotinas } = useContext<any>(AuthContext);

  const [batismoclick, setClickbatismo] = useState<boolean>(false);

  const { pathname } = useLocation();

  const menus = usuarioRotinas.map((rotina: Rotina) => rotina.nomemenu);
  const rotinas = usuarioRotinas.map((rotina: Rotina) => rotina.nomerotina);

  return (
    <>
      {
        menus.some((menu: string) => menu == "Batismo") ?
          <ButtonRotina onClick={() => { setClickbatismo(!batismoclick); }}>
            <Organize active={pathname?.match('batismo')}>
              <Agrup>
                <Icon src={batismo} />
                <p>Batismo</p>
              </Agrup>
              <Seta active={batismoclick} src={seta} />
            </Organize>

            {
              batismoclick ?

                <SubAgrup onClick={(event) => event?.stopPropagation()}>
                  {
                    rotinas.some((rotina: string) => rotina == "Dashboard Batismo") ?
                      <ButtonMenu direcao="/dash/batismo/dashbatismo" nomeEstilo="subitem" titulo="Dashboard de Batismo" />
                      : false
                  }
                  {
                    rotinas.some((rotina: string) => rotina == "Membros Cadastrados") ?
                      <ButtonMenu direcao="/dash/batismo/membros" nomeEstilo="subitem" titulo="Membros Cadastrados" />
                      : false
                  }
                  {
                    rotinas.some((rotina: string) => rotina == "Presença Batismo") ?
                      <ButtonMenu direcao="/dash/batismo/presenca" nomeEstilo="subitem" titulo="Presença do Batismo" />
                      : false
                  }
                  {
                    rotinas.some((rotina: string) => rotina == "Evento Batismo") ?
                      <ButtonMenu direcao="/dash/batismo/eventos" nomeEstilo="subitem" titulo="Controle de Eventos" />
                      : false
                  }
                </SubAgrup>

                : false
            }

          </ButtonRotina>
          : false
      }
    </>
  )
}
